import moment from 'moment';

function gridIndexes(entries, key) {
  const index = [0];
  let initial = entries[0][key];
  for (let i = 0; i < entries.length; i += 1) {
    if (initial !== entries[i][key]) {
      index.push(i);
      initial = entries[i][key];
    }
  }
  return index.map((v, i, arr) => {
    const next = arr[(i + 1)];
    return { start: (v + 1), end: (next + 1) || (entries.length + 1) };
  });
}

export default function headerPlanningNumerique(h, debutPeriode, dureeEnJours, callback = null) {
  const current = moment(debutPeriode.toDate());
  const finPeriode = moment(debutPeriode.toDate()).add(dureeEnJours, 'days');
  const days = [];
  while (finPeriode.isAfter(current)) {
    days.push({
      isodate: current.toDate(),
      date: current.date(),
      week: current.week(),
      day: current.weekday(),
      month: current.format('MMM'),
    });
    current.add(1, 'days');
  }

  const months = [...new Set(days.map(d => d.month))];
  const weeks = [...new Set(days.map(d => d.week))];
  const listDays = days.map(d => ({
    date: d.date,
    saturday: (d.day === 5),
    sunday: (d.day === 6),
    formatedDate: moment(d.isodate).format('YYYY-MM-DD[T]HH:mm:ss'),
  }));
  const monthChangesIndexes = gridIndexes(days, 'month');
  const weekChangesIndexes = gridIndexes(days, 'week');
  const dayChangesIndexes = gridIndexes(days, 'day');

  return h('div',
    {
      class: { 'planning-wrapper-grid': true },
      style: { '--grid-columns': listDays.length },
    }, [

      ...months.map((m, mi) => {
        const grid = monthChangesIndexes[mi];
        const { start, end } = grid;
        return h('div',
          {
            class: {
              month: true,
            },
            style: {
              '--start': start,
              '--end': end,
            },
          }, m);
      }),

      ...weeks.map((w, wi) => {
        const grid = weekChangesIndexes[wi];
        const { start, end } = grid;
        return h('div',
          {
            class: {
              week: true,
            },
            style: {
              '--start': start,
              '--end': end,
            },
          }, `S${w}`);
      }),

      ...listDays.map((d, di) => {
        const { start, end } = dayChangesIndexes[di];
        return h('div',
          {
            attrs: {
              'data-date': d.formatedDate,
            },
            class: {
              day: true,
              pointer: !!callback,
              saturday: d.saturday,
              sunday: d.sunday,
            },
            ...(callback ? {
              on: {
                click: callback,
              },
            } : null),
            style: {
              '--start': start,
              '--end': end,
            },
          }, d.date);
      }),

    ]);
}
